/// <amd-module name="typeahead/features/IncludeHotelsNearRegion" />
/// <amd-dependency path="jquery" name="$"/>
/// <amd-dependency path="typeahead/core/loc" name="loc"/>

/// <reference path="../../typings/typeahead/loc.d.ts" />

"use strict";

import {IInputElementConfig} from "typeahead/core/ExpediaSuggestServiceRequestGenerator";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IDropdownContentHandler} from "typeahead/core/presentation/IDropdownContentHandler";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";
import {addFeatureFlag} from "typeahead/dataprovider/suggestservice/SuggestServiceQueryParamsUtils";

const configuration: IStripingConfiguration[] = [{
        experiment: {
            id: 13081,
            name: "OneSearchTypeahead",
        },
        lobs: ["HOTELS"],
}];

const featureFlag = "onesearchta";
const hotelNameHotelBits = 128; // (hotelNameHotelBits >>> 0).toString(2) = "10000000"

export class IncludeHotelsNearRegion implements IRequestUrlParamModifier, IDropdownContentHandler<undefined>,
    IExperimentalFeature {
    private readonly applicableClientIds: string[] = ["Hotels.Search"];
    private readonly applicableTextInputElementIds: string[] = ["inpSearchNear"];
    // Check for input element ID as well (Only for change search)
    public modifyParameters(params: ISuggestServiceQueryParams, context: IContext, options?: IInputElementConfig):
            JQueryPromise<ISuggestServiceQueryParams> {
        const def: JQueryDeferred<ISuggestServiceQueryParams> = $.Deferred();
        /* Verify that the experiment is only for HSRP and for Change search input TA*/
        if (this.applicableClientIds.indexOf(TypeaheadUtils.getClientId()) > -1
            && this.applicableTextInputElementIds.indexOf(options.inputElementId) > -1) {
            ExecutionHelper.shouldExecute(context, configuration)
                .done((result: boolean): void => {
                    if (result) {
                        params.rid = options.searchRegionId;
                        /* tslint:disable-next-line: no-bitwise */
                        params.mask |= hotelNameHotelBits;

                        // make the call to add parameters
                        addFeatureFlag(featureFlag, configuration, params, context);
                    }
                })
                .always((): void => {
                    def.resolve(params);
                });
        } else {
            def.resolve(params);
        }
        return def.promise();
    }

    public handleContentToShow($dropDownElement: JQuery, $inputElement: JQuery, context: IContext):
            JQueryPromise<undefined> {
        const deferred: JQueryDeferred<undefined> = $.Deferred();
        /* Verify that the experiment is only for HSRP and for Change search input TA*/
        if (this.applicableClientIds.indexOf(TypeaheadUtils.getClientId()) > -1
            && this.applicableTextInputElementIds.indexOf($inputElement.attr("id")) > -1) {
            ExecutionHelper.shouldExecute(context, configuration)
                .done((shouldExecute: boolean): void => {
                    if (shouldExecute) {
                        this.showHotelNameSearchSupportedInfo($dropDownElement);
                    }
                })
                .always((): void => {
                    deferred.resolve(undefined);
                });
        } else {
            deferred.resolve(undefined);
        }
        return deferred.promise();
    }

    public getExperiments(): UtaExperiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    private showHotelNameSearchSupportedInfo($dropDownElement: JQuery) {
        let contentLiStyle: string =    "padding-top:0.92307692em;" +
                                        "padding-right:0.92307692em;" +
                                        "padding-bottom:0;" +
                                        "padding-left:0.92307692em;" +
                                        "margin-top:0.92307692em;" +
                                        "border-top-width:1px;" +
                                        "border-top-style:solid;" +
                                        "border-top-color:#DDD;";
        let contentDivStyle: string =   "display:block;" +
                                        "padding-top:0;" +
                                        "padding-right:0.46153846em;" +
                                        "padding-bottom:0;" +
                                        "padding-left:0.46153846em;";

        let contentIconSpanStyle: string = "padding-right:0.76923077em;";
        let contentTextSpanStyle: string = "font-size:0.9em";
        let labelString: string = loc.taOnesearchPromptText ?
                                    loc.taOnesearchPromptText :
                                    "You can also search by hotel name or attraction";
        // Add new child node
        let infoLabelHTML = $.parseHTML("" +
            "<li role='presentation' class='' " +
            "style=" + contentLiStyle + ">" +
            "<div id='oneSearchTypeaheadPromptInner' style=" + contentDivStyle + ">" +
            "<span class='icon icon-info' aria-hidden='true' style=" + contentIconSpanStyle + "></span>" +
            "<span class='ta-onesearch-prompt-text' style=" + contentTextSpanStyle + ">" + labelString + "</span>" +
            "</div>" +
            "</li>");
        $dropDownElement.find("ul").append(infoLabelHTML);
        // $(infoLabelHTML).after($dropDownElement.find("ul"));

    }
}
